import axios from "axios";
import { IP } from "../index";
// 查询
export async function wxSendAPi(data) {
  var resp = await axios.post(`${IP}/sendService/handSend/send`, {
    ...data,
  });
  return resp.data;
}